import React, { Fragment, memo, useContext, useEffect, useState } from "react";

// Provider

// Temp Images
import _LOADING from "../../../resources/images/icon/loading.gif";

export const LoadingLayer = (props) => {
    return (
        <div className="blacklayer-container" id="loadingLayer">
            <div className="bl-blind" style={{"background":"rgb(0,0,0,0.5)"}}></div>
            <div className="in-layerarea">
                    <img src={_LOADING} alt="" style={{"width":"70px", "height":"70px", "display":"block", "margin":"50% auto"}}/>
            </div>
        </div>
    );
};

export const openLoadingLayer = () => {
    $("#loadingLayer").show();
}

export const closeLoadingLayer = () => {
    $("#loadingLayer").hide();
}